export const initCss = () => {
	document.body.classList.add('default-theme-app');
	const cssVars = [
		{
			name: '--status-bar-height',
			getter: () => window.AndroidInterface?.getStatusBarHeight?.(),
		},
		{
			name: '--navigation-bar-height',
			getter: () => window.AndroidInterface?.getNavigationBarHeight?.(),
		},
	];

	cssVars.forEach(({ name, getter }) => {
		const value = getter();
		if (value) {
			document.documentElement.style.setProperty(name, `${value}px`);
		}
	});
};
